<template>
  <section id="features" class="fade-in section">
    <h2>{{ $t('features.title') }}</h2>
    <div class="features-grid">
      <div class="feature-card" v-for="(item, i) in features" :key="i">
        <div class="feature-icon"><i :class="item.icon"></i></div>
        <h3>{{ $t(item.title) }}</h3>
        <p>{{ $t(item.text) }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesSection',
  data() {
    return {
      features: [
        { icon: 'fas fa-tshirt', title: 'features.cards.fabric.title', text: 'features.cards.fabric.text' },
        { icon: 'fas fa-paint-brush', title: 'features.cards.design.title', text: 'features.cards.design.text' },
        { icon: 'fas fa-truck', title: 'features.cards.delivery.title', text: 'features.cards.delivery.text' },
        { icon: 'fas fa-eye', title: 'features.cards.detail.title', text: 'features.cards.detail.text' }
      ]
    };
  }
};
</script>

<style scoped>
</style>
